import { render } from "./Modal.vue?vue&type=template&id=0a8e6b5f&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=0a8e6b5f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0a8e6b5f"

export default script